import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import ScrollToTop from '../Common/ScrollToTop'
import WhatsAppButton from '../WhatsApp/WhatsAppButton'

const Layout = () => {
    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <ScrollToTop />
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <WhatsAppButton />
        </div>
    )
}

export default Layout
